// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e3248526","239":"2b4d3551","453":"a83f9e5a","732":"dd91a793"}[chunkId] + ".chunk.js";
};